import { createSlice } from '@reduxjs/toolkit'
import { v4 as uuidv4 } from 'uuid';

export const callDetailsSlice = createSlice({
  name: 'callDetails',
  initialState: {
    // unique uuid for the call
   // id: uuidv4(),
    CountryId: null,
    ServiceSubjectName: null,
    Longitude: null,
    Latitude: null,
    isActive: false
  },
  reducers: {
    setCallDetailsCountryId: (state,action) => {
      state.CountryId = action.payload;
    },
    setCallDetailsServiceSubject: (state,action) => {
      state.ServiceSubjectName = action.payload
    },
    setCallDetailsLongLat: (state,action) => {
      const {latitude,longitude} = action.payload
      state.Longitude = longitude
      state.Latitude = latitude
    },
    setCallDetailsActive: (state,action) => {
      state.isActive = action.payload
    }
  },
})

// Action creators are generated for each case reducer function
export const { setCallDetailsCountryId, setCallDetailsServiceSubject, setCallDetailsLongLat, setCallDetailsActive } = callDetailsSlice.actions

export default callDetailsSlice.reducer